import {
    ServiceChargeSettingContract,
    TaxContract,
    CompanyContract,
    VoidCompReasonModel,
} from 'models'
import {
    ModifierOptionLookup,
    IServiceCharge,
    OrderFulfilmentType,
    OrderItemViewModel,
    DiscountContractWithCustom,
    ItemMap,
} from 'store/models/sellModels'
import { linesAndOrderCalculation } from './orderCalculation/linesAndOrderCalculation'

function processOrderSale(
    orderItems: OrderItemViewModel[],
    orderState: {
        currentServiceChageRate: number
        currentFulfilmentType: OrderFulfilmentType
        entireOrderDiscounts: DiscountContractWithCustom[]
        entireOrderVoidComp: VoidCompReasonModel | undefined
    },
    dependencies: {
        serviceChargeSetting: ServiceChargeSettingContract | undefined
        taxes: TaxContract[]
        companySetting: CompanyContract | undefined
        isCalculateCompAfterDiscount: boolean
        modifierOptionMap: ModifierOptionLookup
        itemsMap: ItemMap
    },
) {
    const {
        currentServiceChageRate,
        entireOrderDiscounts,
        entireOrderVoidComp,
    } = orderState
    const {
        taxes,
        companySetting,
        serviceChargeSetting,
        isCalculateCompAfterDiscount,
        modifierOptionMap,
        itemsMap,
    } = dependencies
    const serviceCharge: IServiceCharge = {
        orderServiceChageRate: currentServiceChageRate,
        setting: serviceChargeSetting,
        taxes,
        isTaxInclusive: companySetting?.isTaxInclusive ?? false,
    }

    const {
        calculatedLines: linesCalculated,
        calculatedOrder: orderCalculated,
    } = linesAndOrderCalculation(
        orderItems,
        isCalculateCompAfterDiscount,
        taxes,
        modifierOptionMap,
        itemsMap,
        serviceCharge,
        entireOrderDiscounts,
        entireOrderVoidComp,
    )

    return {
        linesCalculated,
        orderCalculated,
    }
}

export default processOrderSale
